


































































































import { Vue, Component, Prop } from "vue-property-decorator";
import ModalActivityNote from "@/components/Modal/ModalActivityNote.vue";
import { ActivitySchema } from "@/models/activity_schema";
import ActivityService from "@/services/activity_service";
import { EventBus } from "@/events/index";
import moment from "moment";
import { AuthError, APIError, GenericError } from "@/services/error_service";
import { StoreModule } from "@/store/types";
import { CustomerGetters } from "@/store/modules/customer/types";
import { namespace } from "vuex-class";
import { UserGetters } from "@/store/modules/user/types";
import { Roles } from "@/models/roles";
import { GlobalActions } from "@/store/modules/global/types";

@Component({
  components: {
    ModalActivityNote,
  },
})
export default class ActivityNote extends Vue {
  @Prop() selectedCustomer!: number;
  @Prop() notesData!: ActivitySchema[];
  @(namespace(StoreModule.Customer).Getter(CustomerGetters.GetAllCustomers))
  customers;
  @(namespace(StoreModule.User).Getter(UserGetters.GetRole)) role;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddLoading)) setLoading;
  protected Roles = Roles;
  protected moment = moment;
  protected activityService = new ActivityService();
  protected showHistoryDiv = false;
  protected selectedId!: string;

  created() {
    this.selectedId = this.$route.params.id.trim();
  }

  mounted() {
    EventBus.$on(
      "submittedActivity",
      (note: ActivitySchema, isNew: boolean) => {
        this.updateActivityNotes(note, isNew);
      }
    );
    EventBus.$on("showActivityHistory", (show: boolean) => {
      this.showHistoryDiv = show;
    });
  }

  beforeDestroy() {
    EventBus.$off('showActivityHistory');
    EventBus.$off('submittedActivity');
  }

    public displayCreatedBy(info: any): string {
      if (info && info.email) {
        return `<a href="mailto:${info.email}">${info.first_name} ${info.last_name}</a>`
      } else {
        return 'N/A'
      }
    }
  public makeSentenceCase(sentence: string) {
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  public get notes(): ActivitySchema[] {
    return this.notesData.sort((a, b) =>
      a["contacted_at"] < b["contacted_at"] ? 1 : -1
    );
  }

  public getCustomer(id: string): string {
    const result = this.customers.filter((customer) => {
      if (id === customer._id) {
        return customer;
      }
    });
    return result[0] ? result[0].customer_name : "";
  }

  public toggleHistoryDiv(): void {
    this.setLoading(true)
    this.showHistoryDiv = !this.showHistoryDiv;
    EventBus.$emit(
      "showActivityHistory",
      this.showHistoryDiv,
      this.selectedId,
      this.$route.name
    );
    setTimeout(() => this.setLoading(false), 200)
  }

  public async deleteActivity(id: string): Promise<void> {
    try {
      await this.activityService.deleteActivity(id);
      this.$emit("updateNotes", id);
    } catch (err) {
      if (err instanceof AuthError) {
        AuthError.logout();
      } else if (err instanceof APIError) {
        APIError.popup(err.message);
      } else {
        GenericError.popup(err.message);
      }
    }
  }

  public updateActivityNotes(note: ActivitySchema, isNew: boolean): void {
    if (isNew) {
      this.notes.unshift(note);
    } else {
      const results: ActivitySchema[] = [];
      this.notes.forEach((item) => {
        if (item._id === note._id) {
          results.push(note);
        } else {
          results.push(item);
        }
      });
      this.$emit("update", results);
    }
  }

  protected triggerActivityNote(note?: ActivitySchema): void {
    let props = {};
    const options = {
      adaptive: true,
      width: 860,
      height: "auto",
      scrollable: true,
    };
    if (note) {
      props = { isEdit: true, data: note, customerId: note.customer };
      this.$modal.show(ModalActivityNote, { ...props }, { ...options });
    } else {
      this.$modal.show(
        ModalActivityNote,
        { ...props, customerId: this.selectedCustomer },
        { ...options }
      );
    }
  }
}
